import React from "react"
import SingleColumn from "../content/single-column"

interface Props {
  name: string
  value: string
  error: string
  touched: boolean
  handleChange: any
  handleBlur: any
  label: string
  errorClass?: string
  type?: string
}

const TextInput: React.FC<Props> = ({
  name,
  label,
  value,
  error,
  touched,
  handleChange,
  handleBlur,
  errorClass,
  type
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}:
        {touched && error ? <span className={errorClass}> {error}</span> : null}
      </label>
      <input
        id={name}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        type={type || "text"}
      />
    </>
  )
}

export default TextInput
